import styled from "styled-components/macro";
import { PRICING_MOBILE_BREAKPOINT } from "../constants";

export const StyledFeedback = styled.div`
  background: #f5f2e4;
  padding-top: 80px;
  padding-bottom: 80px;
  text-align: center;
  color: black;
  min-height: 500px;

  h1 {
    font-family: "GT Super Text Book";
    margin: auto;
    text-align: center;
    padding: 5px 15px 15px 15px;
    font-weight: 500 !important;
    font-size: 54px;

    &.feedback-headline {
      font-size: 36px;
    }
  }

  > span {
    &:nth-of-type(1) {
      font-family: "Inter";
      color: rgba(43, 35, 21, 0.5);
      font-size: 24px;
      display: block;
      margin-bottom: 10px;
    }
    &:nth-of-type(2) {
      color: rgba(43, 35, 21, 0.5);
      font-size: 24px;
      width: 500px;
      display: block;
      margin: auto;
    }

    &.feedback-pre-headline {
      font-family: "Inter";
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.17em;
    }

    &.feedback-sub-headline {
      font-family: "GT Super Text Book";
      display: block;
      text-align: center;
      font-size: 18px;
      line-height: 20px;
      color: #888;
    }
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    padding: 30px;
    h1 {
      font-size: 30px !important;
    }

    span {
      &:nth-of-type(1) {
        font-size: 15px;
        letter-spacing: 1px;
        padding-top: 30px;
      }
      &:nth-of-type(2) {
        width: auto;
      }
      &.feedback-sub-headline {
        font-size: 22px;
        font-weight: 500;
      }
    }
  }
`;

export const StyledImageGrid = styled.div`
  display: block;
  text-align: center;
  width: 960px;
  margin: auto;
  margin-top: 30px;

  img {
    &:nth-child(1) {
      width: 540px;
      margin-left: -15px;
    }
    &:nth-child(2) {
      float: left;
      width: 392px;
    }
    &:nth-child(3) {
      float: left;
      margin-left: 6px;
      margin-top: 0;
      width: 540px;
      margin-bottom: 8px;
    }
    &:nth-child(4) {
      clear: both;
      display: block;
      margin: auto;
      width: 600px;
      margin-top: 2px;
    }
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    width: 100%;

    img {
      width: 100% !important;
      left: 0;
      right: 0;
      margin: auto;
      margin: 0 !important;
      padding: 0 !important;
      margin-top: 15px;

      &:nth-child(1) {
        float: left;
      }
    }
  }
`;
